<template>
    <div class="widget-tour accordion">
        <div :class="voliTourDisabled? 'card disabled' : 'card'" id="voloAndataId">
            <div class="card-header" @click="onShow(0)">
                <div class="d-flex justify-content-between">
                    <h5>Volo andata</h5>
                    <span v-if="voloAndataTitle" v-tooltip="voloAndataTooltip">{{voloAndataTitle}}</span>
                </div>
            </div>
            <transition>
                <div v-if="isShow(0)" class="collapse show">
                    <div class="card-body pt-2 pb-1">
                        <FilterFlightPanel v-if="panels[0].showAll" :is-from="true" :is-show-flexible-dates="!isExperience" class="my-3" />
                        <FlightPanel ref="flightsFromRef" v-for="(item, index) in flightsFrom" :key="index" :value="item" class="mb-3" :selected="flightFrom.itemId === item.itemId" @select="onFlightFromSelect"/>
                        <ShowMore scroll-to="voloAndataId" :showAll="panels[0].showAll" :remains="counterFlightsFrom" @click="onShowMore"/>
                    </div>
                </div>
            </transition>
        </div>
        <div :class="voliTourDisabled? 'card disabled' : 'card'" id="voloRitornoId">
            <div class="card-header" @click="onShow(1)">
                <div class="d-flex justify-content-between">
                    <h5>Volo ritorno</h5>
                    <span v-if="voloRitornoTitle" v-tooltip="voloRitornoTooltip">{{voloRitornoTitle}}</span>
                </div>
            </div>
            <transition>
                <div v-if="isShow(1)" class="collapse show">
                    <div class="card-body pt-2 pb-1">
                        <FlightPanel ref="flightsToRef" v-for="(item, index) in flightsTo" :key="index" :value="item" class="mb-1" :selected="flightTo.itemId === item.itemId" @select="onFlightToSelect"/>
                        <ShowMore scroll-to="voloRitornoId" :showAll="panels[1].showAll" :remains="counterFlightsTo" @click="(value) => {panels[1].showAll = value.open}"/>
                    </div>
                </div>
            </transition>
        </div>
        <div :class="voliTourDisabled? 'card disabled' : 'card'" id="tourId">
            <div class="card-header" @click="onShow(2)">
                <div class="d-flex justify-content-between">
                    <h5>Tour</h5>
                    <span v-if="tourTitle" v-tooltip="tourTooltip">{{tourTitle}}</span>
                </div>
            </div>
            <transition>
                <div v-if="isShow(2)" class="collapse show">
                    <div class="card-body py-2">
                        <TourPanel :value="tour" />
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="!isTrasferimentoIncluso && hasTraferimenti" :class="trasferimentiDisabled ? 'card disabled' : 'card'" id="trasferimentiId">
            <div class="card-header">
                <div class="d-flex justify-content-between">
                    <h5>Trasferimenti</h5>
                    <span v-if="trasferimentiTitle">{{trasferimentiTitle}}</span>
                    <a href="javascript:void(0)" v-if="trasferimentiSelected.length === 0" class="text-uppercase text-secondary" @click="onOpenTrasferimentiMap()">
                        <div class="btn btn-sm btn-primary rounded">aggiungi trasferimenti</div>
                    </a>
                </div>
            </div>
            <transition>
                <div v-if="trasferimentiSelected.length > 0" class="collapse show">
                    <div class="card-body pt-2 pb-1">
                        <ServicePanel :is-trasferimento="true" v-for="(item, index) in trasferimentiSelected" :key="index" :value="item" :class="index === trasferimentiSelected.length-1 ? '' : 'mb-3'" :selected="true" @detail="onShowTrasferimentoDetail"/>
                        <div class="show-more" v-if="(trasferimenti.length - trasferimentiSelected.length) > 0">
                            <a href="javascript:void(0)" class="py-2 default-bold text-primary" @click="onOpenTrasferimentiMap()">vedi altre {{trasferimenti.length - trasferimentiSelected.length}} alternative</a>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <CompletaPreventivo ref="componentCompletaPreventivo"/>
        <div>
            <ModalServicesMap v-if="!isMobile" :is-trasferimento="true" ref="modalTrasferimentiMap" :list="trasferimenti"/>
            <ModalServicesMobileMap v-else :is-trasferimento="true" ref="modalTrasferimentiMap" :list="trasferimenti"/>
            <ModalServiceDetail v-if="showTrasferimentoItem" ref="modalTrasferimentoDetail" :value="showTrasferimentoItem"/>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DefaultPanel from '../../../templates/DefaultPanel'
import TourPanel from './TourPanel'
import FlightPanel from '../../common/FlightPanel'
import FilterFlightPanel from '../volo-hotel/FilterFlightPanel'
import MessageNext from '../../common/MessageNext'
import FilterServicePanel from '../../common/FilterServicePanel'
import ShowMore from '../../common/ShowMore'
import ServicePanel from '../../common/ServicePanel'
import {voloAndataTitle, voloAndataTooltip, voloRitornoTitle, voloRitornoTooltip} from '../../../../utils/flightUtils'
import CompletaPreventivo from '../../common/CompletaPreventivo'
import CaricaPraticaAction from '../../../actions/CaricaPraticaAction'
import ModalServicesMap from '../../common/modals/ModalServicesMap'
import ModalServiceMobileMap from '../../common/modals/ModalServicesMobileMap'
import ModalServiceDetail from '../../common/modals/ModalServiceDetail'
import MobileDetector from '../../../common/MobileDetector'
import AliveActions from '../../../actions/AliveActions'

const LIMIT_SHOW_VOLI = 1

const initialPanels = [
  { show: true, disabled: false, showAll: false, visible: true },
  { show: true, disabled: false, showAll: false, visible: true },
  { show: true, disabled: false, showAll: false, visible: true },
  { show: false, disabled: true, showAll: false, visible: true }
]

export default {
  name: 'WizzardTour',
  mixins: [CaricaPraticaAction, MobileDetector, AliveActions],
  components: {ModalServiceDetail, ModalServicesMap, ModalServiceMobileMap, CompletaPreventivo, DefaultPanel, TourPanel, FlightPanel, FilterFlightPanel, FilterServicePanel, ServicePanel, ShowMore, MessageNext},
  data: () => {
    return {
      showTrasferimentoItem: null,
      panels: [...initialPanels],
      step: 0
    }
  },
  computed: {
    voliTourDisabled () {
      return this.step >= 3
    },
    trasferimentiDisabled () {
      return this.step !== 3
    },
    voloAndataTitle () {
      return voloAndataTitle(this.flightFrom)
    },
    voloAndataTooltip () {
      return voloAndataTooltip(this.flightFrom)
    },
    voloRitornoTitle () {
      return voloRitornoTitle(this.flightTo)
    },
    voloRitornoTooltip () {
      return voloRitornoTooltip(this.flightTo)
    },
    tourTitle () {
      const tour = this.getTour()
      return tour && tour.anagrafica && tour.anagrafica.element ? tour.anagrafica.element.name : ''
    },
    tourTooltip () {
      return this.tourTitle
    },
    flightFrom () {
      return this.getFlightFrom()
    },
    flightsFrom () {
      return this.getFlightsFrom().filter((item) => {
        return this.panels[0].showAll || this.flightFrom.itemId === item.itemId
      })
    },
    counterFlightsFrom () {
      return this.getAllFlightsFrom().length
    },
    flightTo () {
      return this.getFlightTo()
    },
    flightsTo () {
      return this.getFlightsTo().filter((item) => {
        return this.panels[1].showAll || this.flightTo.itemId === item.itemId
      })
    },
    counterFlightsTo () {
      if (this.panels[1].showAll) return 0
      return this.getFlightsTo().length - LIMIT_SHOW_VOLI
    },
    tour () {
      return this.getTour()
    },
    trasferimentiTitle () {
      const counter = this.trasferimentiSelectedCounter()
      return counter === 0 ? '' : (counter === 1 ? `N° ${counter} trasferimento selezionato` : `N° ${counter} trasferimenti selezionati`)
    },
    trasferimentiSelected () {
      const list = this.getTrasferimentiSelected()
      // ci sono al massimo sempre due trasferimenti, se sono uguali faccio vedere solo il primo
      if (list.length === 2 && list[0].detail.productID === list[1].detail.productID) {
        return [list[0]]
      }
      return list
    },
    trasferimenti () {
      return this.getListaTrasferimenti()
    },
    hasTraferimenti () {
      return this.trasferimenti.length > 0
    },
    isTrasferimentoIncluso () {
      const tour = this.getTour()
      return tour.anagrafica.config.isTrasferimentoIncluso
    }
  },
  methods: {
    ...mapGetters(['getSearch', 'getTour', 'getFlightFrom', 'getFlightsFrom', 'getFlightTo', 'getFlightsTo', 'getAllFlightsTo', 'getAllFlightsFrom', 'getListaTrasferimenti', 'getTrasferimentiSelected', 'trasferimentiSelectedCounter']),
    ...mapActions(['updateVariableStep', 'selectFlightFrom', 'selectFlightTo', 'resetVariableStep']),
    openToDate (item) {
      const filter = item.isTrasferimento ? this.getTrasferimentiFilter() : this.getServiziFilter()
      return filter.data ? filter.data : this.getSearch().partenza
    },
    showFlights () {
      return this.getFlightsFrom().length > 0
    },
    showTransfer () {
      return this.getListaTrasferimenti().length > 0
    },
    isShow: function (index) {
      return this.panels[index].show
    },
    isDisabled: function (index) {
      return this.panels[index].disabled
    },
    isVisible (index) {
      return this.panels[index].visible
    },
    isSelectedTrasferimenti (servizio) {
      const list = this.getTrasferimentiSelected()
      return list.some(item => {
        return servizio.detail.productID === item.detail.productID
      })
    },
    onShow: function (index) {
      this.panels[index].show = !this.panels[index].show
      if (this.panels[index].show) {
        this.step = index
        this.updateVariableStep(index)
      }
    },
    onHideAll (index) {
      this.panels[index].showAll = false
      setTimeout(() => this.$scrollTo(`#app`), 500)
    },
    onOpen: function (index) {
      this.panels[index].show = true
      this.step = index
      this.updateVariableStep(index)
    },
    onOpenPanel (event, index, scrollId) {
      event.stopPropagation()
      this.closeAllPanels()
      this.panels[index].show = true
      this.panels[index].disabled = false
      this.$scrollTo('#' + scrollId, 1000)
    },
    closeAllPanels () {
      this.panels.forEach(item => {
        item.show = false
      })
    },
    onFlightFromSelect (value) {
      this.selectFlightFrom(value)
      const flightToUpdated = this.getFlightsTo()
      if (flightToUpdated.length > 0) {
        this.selectFlightTo(flightToUpdated[0])
      }
      this.$refs.flightsFromRef.forEach(item => {
        item.$forceUpdate()
      })
      this.onHideAll(0)
    },
    onFlightToSelect (value) {
      this.selectFlightTo(value)
      this.$refs.flightsToRef.forEach(item => {
        item.$forceUpdate()
      })
      this.onHideAll(1)
    },
    onShowTrasferimentoDetail (trasferimento) {
      this.showTrasferimentoItem = null
      this.$nextTick(() => {
        this.showTrasferimentoItem = trasferimento
        this.$nextTick(() => {
          this.$refs.modalTrasferimentoDetail.open()
        })
      })
    },
    onOpenTrasferimentiMap (event) {
      event.stopPropagation()
      this.step = 3
      this.updateVariableStep(3)
      this.$refs.modalTrasferimentiMap.open()
      this.openTab('traferimentiId')
    },
    openTab (event) {
      this.closeAllPanels()
      if (event === 'initial') {
        this.onOpen(0)
        this.onOpen(1)
        this.onOpen(2)
        setTimeout(() => this.$scrollTo(`#app`), 500)
        return
      }
      if (event === 'trasferimentiId') this.onOpen(3)
      setTimeout(() => this.$scrollTo(`#${event}`, 300, {offset: -60}), 500)
    },
    onShowMore (value) {
      this.$store.dispatch('resetFlightFilterFrom')
      this.panels[0].showAll = value.open
    },
    completaPreventivo () {
      this.$refs.componentCompletaPreventivo.onCompleta()
    }
  },
  created () {
    this.resetVariableStep()
    this.openTab('initial')
    this.panels[0].visible = this.showFlights()
    this.panels[1].visible = this.showFlights()
    this.panels[3].visible = this.showTransfer()
    this.pingAlive()
  },
  destroyed () {
    this.pingStop()
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/tour-accompagnati/WizzardTour.vue